import api from '@/utils/axios/api';

const BASE = '/api/AuthorBackendTool/api/author';

// 產品類型代碼（revenue 的 byProductType[].productTypeCode）
export const PRODUCT_TYPE_CODE = {
  RichPower: 888003,
  Media: 555003,
  Class: 777004,
};

/**
 * 數據中心總覽 - 營收（總額 + 各產品類型小計 + 時間走勢桶）
 * @param {Object} params from / to / granularity / productType / productId / authorMemberId
 */
export const getRevenue = (params) => api.GET(`${BASE}/sales/revenue`, { params });

/**
 * 銷售明細（cursor 游標分頁，fetchCount 上限 50）
 * 翻頁途中不可變更過濾條件，否則後端回 400
 * @param {Object} params from / to / productType / productId / fetchCount / cursor / authorMemberId
 */
export const getSaleRecords = (params) => api.GET(`${BASE}/sales/records`, { params });

/**
 * 產品下拉清單，回傳的 id 即 revenue / records 的 productId
 * @param {Object} params productType（必填）/ authorMemberId
 */
export const getSaleProducts = (params) => api.GET(`${BASE}/sales/products`, { params });

// 作者清單（僅無敵帳號，非 admin 會拿到 403）
export const getAuthors = () => api.GET(`${BASE}/authors`);

// 某作者旗下的行動 App 清單，沒有 App 時回空陣列
export const getAuthorApps = (authorMemberId) => api.GET(`${BASE}/apps/${authorMemberId}`);
